import { ChakraFlex } from '@equip.health/ui';

import AttendeeListItem from './AttendeeListItem';

interface AttendeeListProps {
  attendees: ScheduleAttendee[];
}

const AttendeeList = ({ attendees }: AttendeeListProps) => {
  return (
    <ChakraFlex direction="column" gridGap="8px" paddingTop="12px">
      {(attendees ?? []).map((attendee) => (
        <AttendeeListItem attendee={attendee} key={attendee.externalId} />
      ))}
    </ChakraFlex>
  );
};

export default AttendeeList;
